/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import customModal from "../customModal/customModal.vue";
import createCraIssue from "../CraManagement/createCraIssue.vue";

export default {
  name: "issuedashboard",
  components: { VPagination, customModal, createCraIssue },
  props: {
    studyId: String,
    siteId: String,
    issueId: {
      type: String,
      default: null
    }
  },

  async mounted() {
    try {
      // Set headers
      if (this.idToken) {
        this.headerValues = {
          headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json",
          },
        };
        const decoded = jwt_decode(this.idToken);
        this.emailId = decoded?.email || "";
      }

      // Get default date format from localStorage
      this.defaultdate = localStorage.getItem("dateformat") || this.defaultdate;

      // Get store values safely
      this.defaultdashboard = store.getters.getdefaultdashboard || null;
      this.roleprivileges = await store.getters.getRolesprivilegeData || null;
      this.valnow = await store.getters.getStudyIs || null;
      console.log("Logged User Privileges:", this.roleprivileges);

      // Load initial issue list
      await this.getIssueList();

      // Event listener for studyId changes
      window.addEventListener("studyIdChanged", async (event) => {
        try {
          this.defaultdashboard = store.getters.getdefaultdashboard || null;
          this.roleprivileges = await store.getters.getRolesprivilegeData || null;
          this.valnow = await store.getters.getStudyIs || null;
          await this.getIssueList();
        } catch (err) {
          console.error("Error in studyIdChanged handler:", err);
        }
      });
    } catch (err) {
      console.error("Error in mounted():", err);
    }
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      SortProperty: "",
      SortOrder: 1,
      issueList: [],
      showIssueModal: false,
      loadingIssues: false,
      issueId: null,
      searchField: {
        visitType: "",
        status: "",
        priority: "",
      },
      selectedcolumnobj: {
        IssueLogId: true,
        Subject: true,
        VisitType: true,
        Severity: true,
        Status: true,
        Priority: true,
        DueDate: true,
        Metrics: true,
        ResolvedAt: true
      },

     visitType: [],
      statuses: ["Open", "In Progress", "Closed"],
      priorities: ["Low", "Medium", "High"],
    };
  },
  // computed:{
  //  isInvestigator(){
  //      return this.roleprivileges?.includes("isInvestigator");
  //  }
  // },
  methods: {
    formatdatetime(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },

    SortSelected(property) {
      console.log("SortPropChanged:", property);

      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      } else {
        this.SortProperty = property;
        this.SortOrder = 0;
      }

      this.activeSortColumn = property;
      this.currentPage = 1;

      console.log(`Sorting by ${this.SortProperty}, order: ${this.SortOrder}`);

      this.getIssueList();
    },

    async getIssueList() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      const emailId = jwt_decode(idtoken).email;

      this.loadingIssues = true;
      try {
        const res = await axios.get(`${this.baseurl}/forms/cra/craissuelist`, {
          params: {
            StudyId: stdid,
            visitType: this.searchField.visitType,
            status: this.searchField.status,
            priority: this.searchField.priority,
            pageindex: this.currentPage,
            pagesize: this.pageSize,
            SortProperty: this.SortProperty,
            SortOrder: this.SortOrder,
          },
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        this.issueList = res.data.results || [];
        this.totalCount = res.data.totalCount;
        this.totalPages = Math.ceil(this.totalCount / this.pageSize);
      } catch (err) {
        console.error("error in getIssueList", err);
        this.issueList = [];
      } finally {
        this.loadingIssues = false;
      }
    },
    search() {
      this.currentPage = 1;
      this.getIssueList();
    },

    async loadPage(page) {
      this.currentPage = page;
      await this.getIssueList();
    },

    EditIssue(issueId) {
      this.issueId = issueId;
      this.showIssueModal = true;
    },
    async DeleteIssue(id) {
      const idtoken = store.getters.getIdToken;
      if (confirm("Are you sure you want to delete this Issue?")) {

        try {
          await axios.delete(
            `${this.baseurl}/forms/cra/deletecraissue?id=${id}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          );
          alert("Issue deleted successfully.");
          this.getIssueList();
        } catch (error) {
          console.error("Error deleting CRA:", error);
        }
      }
    },


    closeIssueModal() {
      this.showIssueModal = false;
      this.issueId = null;
    },
  },
};
